import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import dayjs from '@/dayjs';

import { useBreakpoints } from '@/hooks';

import { resetFilters, store } from './store';

interface ShowHideResetControlsProps {
  open: boolean;
  onToggle: (event: React.MouseEvent) => void;
}

function ShowHideResetControls(props: ShowHideResetControlsProps) {
  const { open, onToggle } = props;
  const { isMobileDevice } = useBreakpoints();
  const { t } = useTranslation();
  const snap = useSnapshot(store);

  const handleResetFilters = () => resetFilters(isMobileDevice);

  const sameAsDefaultFrom = snap.daterange.from?.isSame(
    dayjs().subtract(6, 'month'),
    'month',
  );

  const sameAsDefaultTo = snap.daterange.to?.isSame(dayjs(), 'month');

  const showReset =
    !sameAsDefaultFrom ||
    !sameAsDefaultTo ||
    snap.selectedTemperatures.length > 0 ||
    snap.selectedReeferAges.length > 0 ||
    snap.selectedTradelanes.length > 0 ||
    (isMobileDevice && snap.selectedRefrigerationUnitModels.length > 0);

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignSelf: { xs: 'flex-end', sm: 'center' },
      }}
    >
      <Button
        size="small"
        endIcon={
          <ArrowDropUpIcon
            sx={{
              transition: 'all 200ms ease',
              transform: open ? 'rotate(0)' : 'rotate(180deg)',
            }}
          />
        }
        onClick={onToggle}
      >
        {t('filters.filters')}
      </Button>
      {showReset && (
        <Button
          size="small"
          endIcon={<RestartAltIcon />}
          onClick={handleResetFilters}
        >
          Reset
        </Button>
      )}
    </Stack>
  );
}

export { ShowHideResetControls };
